<yu-button
  expand="block"
  [color]="startedChronometer ? 'error' : 'gradient'"
  [disabled]="disabled"
  (yuClick)="clickButton.emit()"
>
  <div
    class="label-time"
    [ngClass]="{'started-chronometer': startedChronometer}"
  >
    @if (startedChronometer) {
      {{ 'COMMON.FINISH' | translate }} <span>{{ productionChronometerHours }}:{{ productionChronometer | date: 'mm:ss' }}</span>

    } @else {
      {{ 'COMMON.START' | translate }}
    }
  </div>
</yu-button>
